import React, { useEffect, useMemo, useState } from "react";
import { Button, Divider, Modal, Select } from "antd";
import { useTranslation } from "react-i18next";
import { FaPhoneVolume } from "react-icons/fa6";
import { CALL_TYPE } from "./AlertBox";

const PersonnelInChargePopup = ({ type, visible, onCancel, onOK, assigners = [], listSpeakerSip = [], deviceLinks = [] }) => {
  const { t } = useTranslation();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [speaker, setSpeaker] = useState('');

  const options = useMemo(() => {
    return type === CALL_TYPE.PHONE
      ? assigners.map(assigner => ({
        label: `${assigner.phoneNumber}(${assigner.fullName})`,
        value: assigner.phoneNumber
      }))
      : listSpeakerSip.filter(speaker => deviceLinks.some(item => item.toDevice === speaker.serial)).map(item => ({
        label: item.name,
        value: item.serial,
      }))
  }, [assigners, listSpeakerSip, type])

  useEffect(() => {
    if (type === CALL_TYPE.PHONE) {
      if (options.length) {
        setPhoneNumber(assigners[0]?.phoneNumber);
      }
    } else {
      if (options.length) {
        setSpeaker(deviceLinks[0]?.toSerial);
      }
    }
  }, [assigners, deviceLinks]);

  return (
    <Modal
      title={t(type === CALL_TYPE.PHONE ? 'Select personnel in charge' : 'Select a speaker')}
      centered
      visible={visible}
      onOk={() => onOK()}
      onCancel={() => {
        onCancel();
        setPhoneNumber('');
        setSpeaker('');
      }}
      width="20%"
      footer={false}
      maskClosable={false}
      destroyOnClose
      getContainer={() => document.getElementById('main-live-page')}
    >
      <div id="select-personnel-in-charge">
        <Select
          style={{width: '100%'}}
          value={type === CALL_TYPE.PHONE ? phoneNumber : speaker}
          onSelect={value => {
            type === CALL_TYPE.PHONE ? setPhoneNumber(String(value)) : setSpeaker(String(value));
          }}
          getPopupContainer={() => document.getElementById('select-personnel-in-charge')}
        >
          {
            options.map((option, index) => (
              <Select.Option key={index} value={option.value}>{option.label}</Select.Option>
            ))
          }
        </Select>
      </div>

      <Divider/>

      <div style={{ textAlign: "center" }}>
        <Button
          icon={<FaPhoneVolume size={12} />}
          disabled={(!phoneNumber && type === CALL_TYPE.PHONE) || (!speaker && type === CALL_TYPE.SPEAKER)}
          onClick={() => {
            const selectedSpeaker = listSpeakerSip.find(item => item.serial === speaker);
            onOK(type === CALL_TYPE.PHONE ? phoneNumber : selectedSpeaker.accountSip);
            onCancel();
          }}
        >
          <span style={{ display: "inline-block", marginLeft: "6px" }}>
            {t('Call')}
          </span>
        </Button>
      </div>
    </Modal>
  )
}

export default PersonnelInChargePopup;